



















































import { Vue, Component, Prop } from "@/shared/vuepack";
import { claimHsabAccount } from "@/shared/api/userService";
import SupportCard from "@/shared/components/SupportCard.vue";
import Button from "@/shared/components/ui/Button.vue";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import PasswordSetup from "@/employee/components/shared/PasswordSetup.vue";
import { LoginRouteNames } from "@/shared/loginRoutes";
import { isMobileApp } from "@/shared/mobileHelper";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { useCredentialFlowStore } from "@/employee/store/credentialFlow";
import passwordValidation from "@/shared/passwordValidation";

@Component({
  components: {
    Button,
    LoginWrapper,
    PasswordSetup,
    SupportCard
  }
})
export default class HsabClaimAccountVerify extends Vue {
  notifierStore = useNotifierStore();
  userStore = useUserStore();
  credentialFlowStore = useCredentialFlowStore();

  isSubmitting = false;
  password = "";
  username = "";
  showStartOverButton = false;

  @Prop()
  routeToLogin;

  get submitDisabled () {
    return this.isSubmitting;
  }

  mounted () {
    if (!this.credentialFlowStore.credentialFlowUsername) {
      this.$router.push({ name: LoginRouteNames.OktaLogin });
    }
  }

  onSubmit () {
    this.isSubmitting = true;
    this.validateAll()
      .then(result => {
        if (!result) {
          this.isSubmitting = false;
          return;
        }

        this.verifyAccount();
      })
      .catch(() => {
        this.isSubmitting = false;
      });
  }

  validateAll () {
    return this.$validator.validateAll()
      .then(isValid => {
        if (!isValid) {
          return Promise.resolve(false);
        }

        return passwordValidation.validate(this.password);
      })
      .catch(error => {
        let message = "Please choose another password.";

        if (error && error.message) {
          message = error.message;
        }

        this.notifierStore.setDanger(message);

        return Promise.resolve(false);
      });
  }

  verifyAccount () {
    this.showStartOverButton = false;

    claimHsabAccount({
      bendUserId: this.credentialFlowStore.bendUserId,
      identityProofingOptionType: this.credentialFlowStore.selectedIdentityOption.optionType,
      username: this.username,
      password: this.password,
      email: this.credentialFlowStore.email,
      signature: this.credentialFlowStore.signature,
      isMobileApp: isMobileApp()
    })
    .then(() => {
      this.userStore.setLoginUsername(this.username);
      this.$router.push(this.routeToLogin);
      this.notifierStore.setSuccess("Thank you for setting up your password. You may now log in.");
    })
    .catch(err => {
      const errMsg = this.getErrorMessage(err);
      this.showStartOverButton = true;
      this.notifierStore.setDanger(errMsg);
    })
    .finally(() => {
      this.isSubmitting = false;
    });
  }

  getErrorMessage (err: any) {
    return err && err.response && err.response.data && err.response.data.errorMessage
      ? err.response.data.errorMessage
      : "Something went wrong.";
  }
}
